import type {
  DepartureSubUpdateRequest,
  DepartureSubUpdateResponse,
} from '@sola/schema/dotcom/proxy-api/departures.ts';
import { userErrorBadParam } from '@sola/shared-utils/errors/misc.ts';
import { httpPutWithStatus } from '@sola/shared-utils/httpClient.ts';

import { MY_API_BASE } from '../constants.ts';

type DepartureSubUnavailableResponse = Extract<
  DepartureSubUpdateResponse,
  { success: false }
>;

export class DepartureSubUnavailableError extends Error {
  constructor(public readonly response: DepartureSubUnavailableResponse) {
    super('The selected replacement child is unavailable.');
    this.name = 'DepartureSubUnavailableError';
  }
}

export const routeDepartureSubUpdate = (
  supporterId: string,
  departedChildGlobalId: string,
) =>
  `${MY_API_BASE}/supporters/${supporterId}/departures/${departedChildGlobalId}/`;

export const updateDepartureSub = async (
  supporterId: string | undefined,
  departedChildGlobalId: string | undefined,
  payload: DepartureSubUpdateRequest,
): Promise<DepartureSubUpdateResponse> => {
  if (!supporterId) {
    throw userErrorBadParam('supporterId');
  }

  if (!departedChildGlobalId) {
    throw userErrorBadParam('departedChildGlobalId');
  }

  const { response, statusCode } =
    await httpPutWithStatus<DepartureSubUpdateResponse>(
      routeDepartureSubUpdate(supporterId, departedChildGlobalId),
      payload,
      {
        signRequest: true,
      },
    );

  if (!response || ![200, 409].includes(statusCode)) {
    throw userErrorBadParam('departureSubUpdate');
  }

  if (statusCode === 409) {
    if (response.success) {
      throw userErrorBadParam('departureSubUpdate');
    }

    throw new DepartureSubUnavailableError(response);
  }

  return response;
};
